// Modules waar "lezen" óók betekent: eigen gegevens indienen/bewerken (uren, verlof, berichten, …).
// Hier wordt de generieke knoppen-verberging NIET toegepast; pagina's regelen beheer-acties zelf via kanBewerken.
export const EIGEN_MODULES = new Set([
  "Mijn uren", "Mijn uren & reiskosten", "Mijn reiskosten", "Declaraties", "MijnCommissie", "Mijn boetes",
  "Verlof", "Berichten", "Taken", "Tickets", "Contante betalingen", "Werkbus-overdracht", "Leenauto",
  "Bedrijfsactiviteiten", "Verbeteringen", "Meekijkformulieren", "Takenpakketten", "Training",
  "Live locatie", "Mijn dashboards", "Snelkoppelingen",
]);

// Puur informatieve modules: geen bewerk-acties, dus geen alleen-lezen-balk.
export const INFORMATIEF_MODULES = new Set([
  "Dashboard", "AI Assistent", "Uitgebreide dashboards", "AI-Rapportages", "Agenda-dashboard", "Sync status",
  "Locatie-kaart", "Audit log", "Omzet analytics", "Cash Flow", "Debiteuren KPI", "Extras",
]);
